// api/index.ts
import axios from "axios";
import { auth } from "../firebase";
import { getIdToken } from "firebase/auth";

const baseURL = import.meta.env.VITE_API_URL_1 || import.meta.env.VITE_API_URL || "http://localhost:5000";

export const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔥 Request interceptor
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;

  if (user) {
    try {
      // Always fetch fresh token
      const token = await getIdToken(user, true);
      config.headers.Authorization = `Bearer ${token}`;
    } catch (err) {
      console.error("Failed to attach token:", err);
    }
  }

  return config;
});

// 🔥 Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.message ||
      (error.code === "ERR_NETWORK"
        ? "Network connection lost. Please check your internet."
        : "Unexpected server error. Please try again later.");

    error.formattedMessage = message;
    return Promise.reject(error);
  }
);
